export interface I18nData {
  [key: string]: string | any;
}
/**
 * get i18nData by language, return en data if not found
 * @param i18nData sample: { "zh-Hant": "chinese 2", en: "en-item2", 'zh-cn': { name: 'tom'} } | "item 1",
 * @param lang  target language key
 * @param arrEnglishKey optional: english lang key, default: ['en', 'enUs', 'default']
 * @returns
 */
export function getI18nData(
  i18nData: I18nData | string | undefined,
  lang: string,
  arrEnglishKey: string[] = ['en', 'enUs', 'default'],
) {
  if (!i18nData) {
    return '';
  }
  if (typeof i18nData === 'string') {
    return i18nData;
  }
  const data = i18nData[lang];
  if (data) {
    return data;
  }
  // data in English
  let enData;
  for (let i = 0; i < arrEnglishKey.length; i++) {
    const defaultLang = arrEnglishKey[i];
    enData = i18nData[defaultLang];
    if (enData) {
      break;
    }
  }
  if (arrEnglishKey.includes(lang)) {
    return enData;
  }
  // data in non-English
  const arrKey = Object.keys(i18nData); // ['zh-Hant', 'zh-cn', 'default', 'en']
  const nonEnglishKey = arrKey.find((key) => !arrEnglishKey.includes(key));
  return nonEnglishKey ? i18nData[nonEnglishKey] : enData;
}

/**
 * get agent name in i18n data, return displayName by default
 * @param i18nData
 * @param lang
 * @param showDisplayName
 * @returns
 */
export function getAgentName(i18nData: NameModel, lang: string, showDisplayName = true) {
  const name = getI18nData(i18nData, lang);
  if (typeof name === 'string') {
    return name;
  }
  let strName = '';
  if (typeof name === 'object') {
    if (showDisplayName && name.displayName) {
      return name.displayName;
    }
    if (name.nickName && name.nickName.trim() !== '') {
      strName = `${name.nickName} ${name.surname}`;
    } else if (name.otherName && name.otherName.trim() !== '') {
      strName = `${name.otherName} ${name.surname}`;
    } else {
      strName = `${name.firstName || ''} ${name.surname || ''}`;
    }
    if (lang.includes('zh')) {
      // chinese format: surname firstname
      const nameLocal = `${name.surname || ''}${name.firstName || ''}`;
      return nameLocal || strName;
    }
  }
  return strName;
}

export interface NameModel {
  zhHk: {
    surname: string;
    firstName: string;
  };
  enUs: {
    displayName: string;
    surname: string;
    firstName: string;
    otherName: string;
    nickName: string;
  };
  kmKm: {
    surname: string;
    firstName: string;
  };
  thTh: {
    surname: string;
    firstName: string;
  };
}
